import _ from "lodash"
import appState, * as appStateOther from "./app-state"
import courseCalendar from "./course-calendar"
import printConfigurator from "./print-configurator"
import routine from "./routine"
import user from "./user"

let allActions = [appState, appStateOther, printConfigurator, user, routine, courseCalendar]

let allKeys = _.keys(_.assign({}, ...allActions))

let allKeysAsStrings = _.reduce(_.sortBy(allKeys), (str, key) => `${str}"${key}"\n`, "")

// If we end up importing names of actions (like they do in redux), we'd use
// this to generate that set. Right now, babel doesn't error if we import
// a named export that doesn't exist

// let mapOfActionNamesToStrings = _.chain(allActions)
//   .flatMap(actionMap => _.map(actionMap, (val, key) => key))
//   .reduce((acc, key) => _.assign(acc, {[key]: key}), {})
//   .reduce((acc, val, key) => {
//     return `${acc}export const ${key} = "${key}"\n`
//   }, "")
//   .value()

// console.log('mapOfActionNamesToStrings')
// console.log(mapOfActionNamesToStrings)

// export const actionNames = mapOfActionNamesToStrings

export default _.assign({}, ...allActions)
